import React from 'react';
import { useSidebar } from './SidebarContext';

const Header = ({ title }) => {
    const sidebar = useSidebar();

    return (
        <>
            <style>{`
                .wa-header {
                    background: #FFFFFF;
                    border-bottom: 1px solid #E5E7EB;
                    box-shadow: 0 2px 8px rgba(30, 58, 95, 0.04);
                    z-index: 1020;
                    position: sticky;
                    top: 0;
                    flex-shrink: 0;
                }

                .wa-header-title {
                    color: #333333;
                    letter-spacing: -0.3px;
                    font-size: 1.15rem;
                }

                .wa-header-icon {
                    font-size: 1.35rem;
                    color: #1A73E8;
                }

                .wa-header-user {
                    font-size: 0.85rem;
                    color: #333333;
                }

                .wa-header-status {
                    font-size: 0.75rem;
                    color: #4CAF50;
                }

                .wa-header-status .status-dot {
                    font-size: 0.5rem;
                    vertical-align: middle;
                    margin-right: 4px;
                }

                .wa-header-avatar {
                    width: 40px;
                    height: 40px;
                    font-size: 1rem;
                    background: #FFF3CD;
                    color: #333333;
                    border: 2px solid #E5E7EB;
                }

                .wa-menu-toggle {
                    display: none;
                    background: #1E3A5F;
                    border: none;
                    color: white;
                    width: 38px;
                    height: 38px;
                    min-width: 38px;
                    border-radius: 10px;
                    font-size: 1.25rem;
                    cursor: pointer;
                    align-items: center;
                    justify-content: center;
                    transition: background 0.2s;
                    margin-right: 12px;
                }

                .wa-menu-toggle:hover {
                    background: #1A73E8;
                }

                @media (max-width: 991px) {
                    .wa-menu-toggle {
                        display: flex;
                    }
                }

                @media (max-width: 576px) {
                    .wa-header {
                        padding-left: 16px !important;
                        padding-right: 16px !important;
                    }

                    .wa-header-title {
                        font-size: 1rem;
                    }
                }
            `}</style>

            <header className="wa-header sticky-top d-flex align-items-center justify-content-between px-4 py-3 mb-0">
                <div className="d-flex align-items-center">
                    {sidebar && (
                        <button
                            className="wa-menu-toggle"
                            onClick={sidebar.toggleSidebar}
                            aria-label="Open menu"
                            type="button"
                        >
                            <i className="bi bi-list" aria-hidden="true" />
                        </button>
                    )}
                    <i className="bi bi-whatsapp wa-header-icon me-3 d-none d-sm-inline" aria-hidden="true" />
                    <h4 className="m-0 fw-bold wa-header-title">
                        {title}
                    </h4>
                </div>

                <div className="d-flex align-items-center">
                    <div className="text-end me-3 d-none d-md-block">
                        <p className="m-0 fw-bold wa-header-user">Admin User</p>
                        <p className="m-0 fw-bold wa-header-status">
                            <i className="bi bi-circle-fill status-dot" aria-hidden="true" /> System Online
                        </p>
                    </div>
                    <div className="wa-header-avatar rounded-circle d-flex align-items-center justify-content-center fw-bold shadow-sm">
                        A
                    </div>
                </div>
            </header>
        </>
    );
};

export default Header;
